import { Component, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserDefinedFactor } from './user-defined-factor.model';

@Component({
  selector: 'app-user-defined-factor',
  imports: [FormField, MatInputModule, MatCheckboxModule, MatTooltipModule],
  templateUrl: './user-defined-factor.component.html',
  styles: ``,
})
export class UserDefinedFactorComponent {

  readonly form = input.required<FieldTree<UserDefinedFactor>>();

  ngOnDestroy() {

    if (!this.form().value().valid())
      this.form().value().value.set(1);

  }

}
